import type { CaseDetail } from "./api";

const steps = [
  { key: "INQUIRY_CONFIRMED", short: "询", name: "询单确认" },
  { key: "INITIAL_SOURCING", short: "查", name: "首次查货" },
  { key: "INITIAL_QUOTING", short: "报", name: "首次报价" },
  { key: "SALES_FOLLOW_UP", short: "跟", name: "销售跟进" },
  { key: "AWAITING_PAYMENT", short: "付", name: "已付款" },
  { key: "AWAITING_PROCUREMENT", short: "购", name: "已采购" },
];

export function CaseProgressBar({ detail }: { detail: CaseDetail }) {
  const visibleSteps = [
    ...steps.slice(0, 4),
    ...(detail.customMetrics
      ?.filter((item) => item.enabled)
      .map((item) => ({
        ...item,
        short:
          item.shortName?.trim() ||
          (steps.find(
            (step) => step.key === item.key && step.name === item.name,
          )?.short ??
            Array.from(item.name)[0]),
      })) ?? steps.slice(4)),
  ];
  const automaticIndex = visibleSteps.findIndex(
    (step) => step.key === detail.automaticProgress,
  );
  return (
    <ol className="case-header-progress" aria-label="订单进度">
      {visibleSteps.map((step, index) => {
        // Manual stages are independent selections, not a cumulative sequence.
        const reached =
          !detail.progressReviewRequired &&
          (index < 4
            ? automaticIndex >= index
            : detail.manualProgress.includes(step.key));
        const current =
          !detail.progressReviewRequired && detail.currentProgress === step.key;
        const label = `${step.name}：${detail.progressReviewRequired ? "历史进度待确认" : current ? "当前进度" : reached ? "已完成" : "未完成"}`;
        return (
          <li
            key={step.key}
            className={reached ? "is-complete" : undefined}
            aria-current={current ? "step" : undefined}
            aria-label={label}
            title={label}
          >
            <span className="case-header-progress-circle" aria-hidden="true">
              {step.short}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
